import { addYears, formatISO } from 'date-fns';
import { merge } from 'lodash';
import { useMemo } from 'react';
/**
 * @TODO
 * Handle remaining fields from old config
 * - backgroundDimmingEnabled
 * - ... maybe more
 */
export const useDefaultConfig = ({
  config
}) => {
  return useMemo(() => merge({
    submitButtonVisible: true,
    submitButtonLabel: 'search',
    destinationField: {
      required: true,
      fetchDestinations: () => Promise.resolve([]),
      topDestinations: [],
      topRegionsListType: 'default',
      recentSearches: false,
      promotionItems: null,
      topPromotionItems: null
    },
    airportsField: {
      required: true,
      airports: [],
      nearByAirports: [],
      countryCode: 'de',
      enableSelectAll: true,
      forcedNeutralLabel: false,
      showSuggestions: true
    },
    travellersField: {
      required: true,
      adultCountMin: 1,
      adultCountMax: 7,
      childrenCountMin: 0,
      childrenCountMax: 6,
      childrenAgeMin: 1,
      childrenAgeMax: 18,
      maxTravellers: 8
    },
    travellersFieldMultiroom: {
      required: true,
      adultsCountMin: 1,
      adultsCountMax: 7,
      adultsCountMinPerRoom: 1,
      childrenCountMin: 0,
      childrenCountMax: 6,
      childrenAgeMin: 1,
      childrenAgeMax: 18,
      travellersCountMax: 8,
      roomsCountMax: 4
    },
    travelPeriodField: {
      required: true,
      defaultDuration: {
        min: 7,
        max: 14
      },
      // @FIXME null?
      withoutDuration: false,
      minDate: formatISO(Date.now(), {
        representation: 'date'
      }),
      maxDate: formatISO(addYears(Date.now(), 2), {
        representation: 'date'
      }),
      durationOptions: [],
      durationOptionsNew: [],
      durationLimit: Infinity,
      holidayDates: []
    },
    layout: 'full',
    hasNextDP: false,
    showHolidays: false,
    multiroom: false,
    dimming: false
  }, config), [config]);
};